// extracted by mini-css-extract-plugin
export var tosLink = "_5m-0";